import { useLazyQuery } from "@apollo/client";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { clientNeoFact } from "@neonumy/api-clients";
import { READY_FOR_EXPORT_NEOFACT } from "queries/neoFact/settings";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function useReadyForExport() {
  const { companyId } = useParams();
  const [isLoadingReadyFACT, setIsLoadingReadyFACT] = useState(false);

  const [
    readyForExportNeofactQuery,
    { refetch, data: readyForExportData, error: readyForExportError },
  ] = useLazyQuery<ReadyForExportOutput, ReadyForExportInput>(READY_FOR_EXPORT_NEOFACT, {
    client: clientNeoFact,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (readyForExportError) onErrorGraphql(readyForExportError);
  }, [readyForExportError]);

  const totalDocumentsReadyFact = readyForExportData?.readyForExport?.totalDocuments ?? 0;

  useEffect(() => {
    if (readyForExportData) {
      setIsLoadingReadyFACT(false);
    }
  }, [readyForExportData]);

  const readyForExportNeofact = () => {
    setIsLoadingReadyFACT(true);
    readyForExportNeofactQuery({ variables: { companyId } });
  };

  const refetchFact = () => {
    setIsLoadingReadyFACT(true);
    refetch({ companyId });
  };

  return {
    readyForExportNeofact,
    refetchFact,
    totalDocumentsReadyFact,
    isLoadingReadyFACT,
  };
}
